import React, { useState } from 'react';

import { Grid, Button } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';

function obterPeriodoPadrao() {
  return {
    start: moment().startOf('month').toDate(),
    end: new Date(),
  };
}

function FiltroPeriodo({ periodo, onChange }) {
  const [dataInicio, setDataInicio] = useState(periodo.start);
  const [dataFim, setDataFim] = useState(periodo.end);

  const aplicarFiltro = () => {
    onChange({ start: dataInicio, end: dataFim });
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={4}>
        <KeyboardDatePicker
          fullWidth
          format="dd/MM/yyyy"
          label="Data Inicial"
          value={dataInicio}
          onChange={setDataInicio}
          inputVariant="outlined"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <KeyboardDatePicker
          fullWidth
          format="dd/MM/yyyy"
          label="Data Final"
          value={dataFim}
          onChange={setDataFim}
          inputVariant="outlined"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={aplicarFiltro}
          style={{ height: 56 }}
        >
          Aplicar
        </Button>
      </Grid>
    </Grid>
  );
}

export { obterPeriodoPadrao };
export default FiltroPeriodo;
